import html2canvas from 'html2canvas';

/**
 * Convierte un elemento del DOM en una imagen canvas
 * @param {React.RefObject} ref - Referencia al elemento a capturar
 * @param {Object} options - Opciones adicionales de configuración
 * @returns {Promise<HTMLCanvasElement>} El canvas generado
 */
export const captureElementToCanvasHelper = async (ref, options = {}) => {
  // Verificación más robusta de la referencia
  if (!ref) {
    console.error('Se requiere una referencia al elemento DOM');
    throw new Error('Se requiere una referencia al elemento DOM');
  }

  if (!ref.current) {
    console.error('La referencia al elemento DOM no está conectada');
    throw new Error('La referencia al elemento DOM no está conectada');
  }

  try {
    const defaultOptions = {
      useCORS: true,
      scale: 2,
      logging: false,
      backgroundColor: '#fff',
      imageTimeout: 0,
      ...options,
      onclone: (clonedDoc) => {
        // Asegura que las imágenes estén cargadas antes de la captura
        const images = clonedDoc.getElementsByTagName('img');
        return Promise.all(
          Array.from(images).map((img) => {
            if (img.complete) return Promise.resolve();
            return new Promise((resolve) => {
              img.onload = resolve;
              img.onerror = resolve;
              // Añadir un timeout por si la imagen nunca carga
              setTimeout(resolve, 2000);
            });
          }),
        );
      },
    };

    const canvas = await html2canvas(ref.current, defaultOptions);
    return canvas;
  } catch (error) {
    console.error('Error al capturar el elemento:', error);
    throw error;
  }
};
